// extracted by mini-css-extract-plugin
export default {"container":"EF-z","header":"FF-z","details":"GF-z","link":"HF-z"};